import { useEffect, useId, useState } from "react";
import { Button } from "../../../design-v2";

export default function CardioItemRow({ item, prescribedMinutes, disabled, onDone }) {
  const [draft, setDraft] = useState(item.cardio?.minutes ?? "");
  const [error, setError] = useState("");
  const errorId = useId();
  const completed = item.cardio?.completed === true;
  const validPrescribedMinutes = Number.isInteger(prescribedMinutes) &&
    prescribedMinutes >= 1 && prescribedMinutes <= 600
    ? prescribedMinutes
    : null;
  const draftIsEmpty = draft === "";

  useEffect(() => {
    setDraft(item.cardio?.minutes ?? "");
    setError("");
  }, [item.cardio?.minutes]);

  function updateDraft(nextDraft) {
    if (!/^\d*$/.test(nextDraft)) return;
    setError("");
    setDraft(nextDraft);
  }

  function done() {
    // Only a first completion may accept the prescribed ghost. Updating an
    // already-completed item needs explicit minutes; a blank Update is neither
    // "accept prescription" nor "un-complete", so stored Cardio stays intact.
    if (completed && draftIsEmpty) {
      setError("Enter minutes to update.");
      return;
    }
    const minutes = draftIsEmpty ? null : Number(draft);
    if (!draftIsEmpty && (!Number.isInteger(minutes) || minutes < 1 || minutes > 600)) {
      setError("Minutes must be from 1 to 600.");
      return;
    }
    setError("");
    onDone(minutes);
  }

  const actionLabel = completed
    ? "Update"
    : draftIsEmpty && validPrescribedMinutes != null
      ? `Done · ${validPrescribedMinutes} min`
      : "Done";

  return (
    <div className="lz-workout-cardio" data-completed={completed || undefined}>
      <div className="lz-workout-cardio__meta">
        <span>Minutes</span>
        {validPrescribedMinutes != null ? (
          <span className="lz-workout-cardio__prescription">
            Prescribed: <strong>{validPrescribedMinutes} min</strong>
          </span>
        ) : null}
      </div>
      <div className="lz-workout-cardio-row">
        {completed ? (
          <span className="lz-workout-cardio__completed" aria-label="Completed">✓</span>
        ) : null}
        <label className="lz-workout-cardio__field">
          <span className="lz-v2-visually-hidden">Minutes</span>
          <span className="lz-workout-cardio__field-control">
            <input
              aria-label="Minutes"
              aria-invalid={Boolean(error)}
              aria-describedby={error ? errorId : undefined}
              type="text"
              inputMode="numeric"
              pattern="[0-9]*"
              maxLength={3}
              value={draft}
              placeholder={!completed && validPrescribedMinutes != null ? String(validPrescribedMinutes) : "—"}
              disabled={disabled}
              onChange={(event) => updateDraft(event.target.value)}
              onKeyDown={(event) => {
                if (event.key === "Enter") done();
              }}
            />
            <span aria-hidden="true">min</span>
          </span>
        </label>
        <Button
          variant="secondary"
          size="sm"
          className="lz-workout-cardio__action"
          disabled={disabled || (!completed && draftIsEmpty && validPrescribedMinutes == null)}
          onClick={done}
        >
          {actionLabel}
        </Button>
      </div>
      {error ? <span id={errorId} className="lz-workout-field-error" role="alert">{error}</span> : null}
    </div>
  );
}
